import Skeleton from "@mui/material/Skeleton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import uniqid from "uniqid";
export const SingleListAvatarShimmer = ({
  enableSubtitle = true,
  avatarVarient,
  avatarStyle,
}: {
  enableSubtitle?: boolean;
  avatarVarient: "circular" | "text" | "rectangular";
  avatarStyle?: { [key: string]: string };
}) => {
  return (
    <List>
      <ListItem
        alignItems={"center"}
        sx={{ marginBottom: "-6px" }}
        key={uniqid()}
      >
        <ListItemAvatar>
          <Skeleton
            animation="wave"
            variant={avatarVarient}
            width={40}
            height={40}
            sx={{ ...avatarStyle }}
          />
        </ListItemAvatar>

        <ListItemText
          primary={
            <Skeleton
              animation="wave"
              height={10}
              width="80%"
              style={{ marginBottom: 6 }}
            />
          }
          secondary={
            enableSubtitle ? (
              <Skeleton animation="wave" height={10} width="40%" />
            ) : null
          }
        />
      </ListItem>
    </List>
  );
};
const AvatarListShimmer = ({
  enableSubtitle = true,
  avatarVarient,
  avatarStyle,
}: {
  enableSubtitle: boolean;
  avatarVarient: "circular" | "text" | "rectangular";
  avatarStyle: { [key: string]: string };
}) => {
  return (
    <List
      sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}
      data-testid="avatarList-shimmer"
    >
      {new Array(10).fill(0).map(() => (
        <SingleListAvatarShimmer
          enableSubtitle={enableSubtitle}
          avatarVarient={avatarVarient}
          avatarStyle={avatarStyle}
          key={uniqid()}
        />
      ))}
    </List>
  );
};

export default AvatarListShimmer;
